import { Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  barsVisibility = signal<boolean>(true)
}
